import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8099 8C11.611 8.00018 11.4204 8.07931 11.2799 8.22L6.14985 13.36C6.10299 13.4065 6.06579 13.4618 6.04041 13.5227C6.01502 13.5836 6.00195 13.649 6.00195 13.715C6.00195 13.781 6.01502 13.8464 6.04041 13.9073C6.06579 13.9682 6.10299 14.0235 6.14985 14.07L6.84985 14.78C6.89633 14.8269 6.95163 14.8641 7.01256 14.8894C7.07349 14.9148 7.13885 14.9279 7.20485 14.9279C7.27086 14.9279 7.33621 14.9148 7.39714 14.8894C7.45807 14.8641 7.51337 14.8269 7.55985 14.78L11.9999 10.33L16.4399 14.78C16.4855 14.8266 16.5399 14.8636 16.6 14.8888C16.6601 14.9141 16.7247 14.9271 16.7899 14.9271C16.855 14.9271 16.9196 14.9141 16.9797 14.8888C17.0398 14.8636 17.0942 14.8266 17.1399 14.78L17.8499 14.07C17.8967 14.0235 17.9339 13.9682 17.9593 13.9073C17.9847 13.8464 17.9978 13.781 17.9978 13.715C17.9978 13.649 17.9847 13.5836 17.9593 13.5227C17.9339 13.4618 17.8967 13.4065 17.8499 13.36L12.7199 8.22C12.5781 8.08112 12.3883 8.0023 12.1899 8H11.8099Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgTopOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTopOutline;
